import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import styles from "./LegalPage.module.scss";

export function PrivacyPolicyPage() {
  return (
    <div className={styles.page}>
      <Helmet>
        <title>Privacy Policy | GoodBaby</title>
        <meta
          name="description"
          content="Learn how GoodBaby protects your data. We use P2P technology so your video never touches our servers."
        />
        <link rel="canonical" href="https://goodbaby.cam/privacy" />
      </Helmet>
      <header className={styles.header}>
        <div className={styles.container}>
          <Link to="/" className={styles.backLink}>
            <ArrowLeft size={16} />
            Home
          </Link>
        </div>
      </header>

      <main className={styles.main}>
        <div className={styles.container}>
          <h1>Privacy Policy</h1>
          <p className={styles.lastUpdated}>Last updated: January 2026</p>

          <section className={styles.section}>
            <h2>1. Introduction</h2>
            <p>
              GoodBaby ("we", "our", or "us") is committed to protecting your
              privacy. This Privacy Policy explains how our secure baby
              monitoring application works and how we handle your data.
            </p>
          </section>

          <section className={styles.section}>
            <h2>2. No Cloud Storage of Video</h2>
            <p>
              The most important thing to know is that{" "}
              <strong>
                GoodBaby does not store, record, or buffer your video or audio
                streams.
              </strong>
            </p>
            <p>
              All communication between your "Baby" device and "Parent" device
              occurs directly (Peer-to-Peer) using WebRTC technology. The video
              feed works like a direct cable between your devices, encrypted
              over the internet.
            </p>
          </section>

          <section className={styles.section}>
            <h2>3. Information We Collect</h2>
            <p>
              Since we do not store video, we only collect the minimum
              information required to operate the service:
            </p>
            <ul>
              <li>
                <strong>Account Information:</strong> Email and password
                (managed safely via authentication providers) to let you sign
                in.
              </li>
              <li>
                <strong>Device Status:</strong> We momentarily track if a device
                is "Online" or "Offline" to help your other devices connect to
                it.
              </li>
              <li>
                <strong>Signaling Data:</strong> To establish a P2P connection,
                devices exchange standard "signaling" messages (like IP
                addresses and ports). These are transient and not stored
                permanently.
              </li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>4. Security</h2>
            <p>We prioritize security above all else:</p>
            <ul>
              <li>
                All streams are encrypted using DTLS (Datagram Transport Layer
                Security) and SRTP (Secure Real-time Transport Protocol).
              </li>
              <li>Authentication is handled by industry-leading providers.</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>5. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please
              contact us.
            </p>
          </section>
        </div>
      </main>

      <footer className={styles.footer}>
        <div className={styles.container}>
          <p>© {new Date().getFullYear()} GoodBaby. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
